import styled from 'styled-components'

export const TableContainer = styled.table`
  ${({ theme: { colors, monoFont } }) => `
  margin: 0.5rem;
  border-spacing: 0;
  border-collapse: collapse;
  border: 1px solid ${colors('foreground', 0.12)};
  width: calc(100% - 1rem);
  font-family: ${monoFont};
  font-size: 0.8rem;
`};
`

export const TableHeader = styled.th`
  ${({ theme: { breakpoint, colors } }) => `
  padding: 0.5rem 1rem;
  text-align: left;
  color: ${colors('foreground', 0.45)};
  font-size: 0.7rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border-bottom: 1px solid ${colors('foreground', 0.15)};
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
  @media screen and (max-width: ${breakpoint('md')}) {
    &.hide-sm{
      display: none;
    }
  }
  `};
`

const Row = styled.tr`
  ${({ theme: { colors }, $clickable }) => `
  border-bottom: 1px solid ${colors('foreground', 0.08)};
  ${$clickable ? 'cursor: pointer;' : ''}
  &:last-child {
    border-bottom: none;
  }
  &:hover td {
    background: ${colors('chrome')};
  }
  &.highlight td {
    background: ${colors('highlight', 0.08)};
  }
`};
`

export const TableHead = styled.thead`
  ${({ theme: { colors } }) => `
  background: ${colors('shadow', 0.4)};
  ${Row} {
    border-bottom: none;
  }
  ${Row}:hover td {
    background: transparent;
  }
`};
`

export const TableBody = styled.tbody``

export const TableTitle = styled.th`
  ${({ theme: { colors } }) => `
  padding: 0.6rem 1rem;
  text-align: left;
  color: ${colors('highlight')};
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border-bottom: 1px solid ${colors('foreground', 0.15)};
`}
`

export const Col = styled.td`
  ${({ theme: { breakpoint, colors } }) => `
  position: relative;
  padding: 0.65rem 1rem;
  color: ${colors('text')};
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
  a.full-cell{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  @media screen and (max-width: ${breakpoint('md')}) {
    &.hide-sm{
      display: none;
    }
  }
`};
`

export const Table = ({
  alternate,
  className,
  columns = [],
  data = [],
  highlight = {},
  interactive = true,
  onRowClick,
  title
}) => {
  return (
    <TableContainer className={className}>
      <TableHead>
        {title && (
          <Row>
            <TableTitle colSpan={columns.length}>{title}</TableTitle>
          </Row>
        )}

        <Row>
          {columns.map((c) => (
            <TableHeader
              className={c.className}
              colSpan={c.colSpan}
              key={JSON.stringify(c)}
              scope="col"
            >
              {typeof c.title === 'function' ? c.title(c) : c.title}
            </TableHeader>
          ))}
        </Row>
      </TableHead>

      <TableBody alternate={alternate}>
        {Object.keys(data).map((rowKey, rowIndex) => (
          <Row
            key={JSON.stringify(rowKey)}
            $clickable={interactive && !!onRowClick}
            onClick={
              interactive && onRowClick
                ? () => onRowClick(data[rowKey], rowIndex)
                : undefined
            }
            className={
              data[rowKey][highlight.key] &&
              data[rowKey][highlight.key] === highlight.val
                ? 'highlight'
                : ''
            }
          >
            {Array.isArray(data[rowKey]) &&
              columns.map((c) => (
                <Col
                  className={`${c.className} overflow`}
                  key={JSON.stringify(c)}
                >
                  {c.key === 'value'
                    ? JSON.stringify(data[rowKey])
                    : JSON.stringify(rowKey)}
                </Col>
              ))}

            {typeof data[rowKey] === 'number' &&
              columns.map((c) => (
                <Col className={c.className} key={JSON.stringify(c)}>
                  {c.render
                    ? c.render(data[rowKey], rowIndex)
                    : JSON.stringify(rowKey)}
                </Col>
              ))}

            {typeof data[rowKey] === 'object' &&
              !Array.isArray(data[rowKey]) &&
              columns.map((c) => (
                <Col className={c.className} key={JSON.stringify(c)}>
                  {c.render
                    ? c.render(data[rowKey][c.key], rowIndex, data[rowKey])
                    : data[rowKey][c.key]}
                </Col>
              ))}
          </Row>
        ))}
      </TableBody>
    </TableContainer>
  )
}
